export interface ParsedRoiFilename {
  prefix: string;
  floor: string;
  zone: string;
  num: string;
}

const PATTERN = /^(P\d+)_([A-Z]?\d+|\d+F)_(\d+)_(\d+)/i;

export function parseRoiFilename(filename: string): ParsedRoiFilename | null {
  const base = filename.replace(/\.json$/i, '');
  const match = base.match(PATTERN);
  if (!match) return null;
  return {
    prefix: match[1].toUpperCase(),
    floor: match[2].toUpperCase(),
    zone: match[3],
    num: match[4],
  };
}

function floorSortKey(floor: string): number {
  const upper = floor.toUpperCase();
  if (upper.startsWith('B')) {
    const n = parseInt(upper.slice(1), 10);
    return Number.isFinite(n) ? -n : 0;
  }
  const fMatch = upper.match(/^(\d+)F?$/);
  if (fMatch) {
    return parseInt(fMatch[1], 10);
  }
  return 0;
}

export function uniqueFloors(filenames: string[]): string[] {
  const set = new Set<string>();
  filenames.forEach((f) => {
    const parsed = parseRoiFilename(f);
    if (parsed) set.add(parsed.floor);
  });
  return Array.from(set).sort((a, b) => floorSortKey(a) - floorSortKey(b));
}

export function uniqueZones(filenames: string[], floor: string | ''): string[] {
  const set = new Set<string>();
  filenames.forEach((f) => {
    const parsed = parseRoiFilename(f);
    if (!parsed) return;
    if (floor && parsed.floor !== floor) return;
    set.add(parsed.zone);
  });
  return Array.from(set).sort((a, b) => Number(a) - Number(b));
}
